import { defineComponent as _defineComponent } from 'vue'
import { ref, useContext } from '@nuxtjs/composition-api'
import { showError } from '~/store/notificationStore'
import XIcon from '@/assets/img/XIcon.svg'
import { useFetcher } from '~/store/useFetcher'
import { useUserStore } from '~/store/userStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackModalContent',
  emits: ["close"],
  setup(__props) {

const {
  $app: { auth },
} = useContext()

const fetcher = useFetcher()
const user = useUserStore()

const isLoading = ref(false)
const formData = ref({
  email: user.isCompany ? auth.currentUser?.email : user.email,
  name: user.isCompany ? user.companyName : user.talentFullName,
  newFeatures: '',
  bugFixes: '',
})
const feedbackSent = ref(false)



async function onFeedbackSubmit() {
  const { newFeatures, bugFixes } = formData.value

  let feedbacks: Array<any> = []

  if (newFeatures) {
    feedbacks.push({
      question: user.isCompany
        ? 'Improvement suggestion from recruiter'
        : 'Improvement suggestion from talent',
      answer: newFeatures,
    })
  }

  if (bugFixes) {
    feedbacks.push({
      question: user.isCompany ? 'Bug report from recruiter' : 'Bug report from talent',
      answer: bugFixes,
    })
  }

  feedbackSent.value = true

  isLoading.value = true

  fetcher
    .$post('/api/feedback', feedbacks)
    .catch((e) => {
      showError({
        message: 'Feedback konnte nicht gesendet werden, denn ein Fehler ist aufgetreten',
      })
      console.error(e)
    })
    .finally(() => (isLoading.value = false))
}

return { __sfc: true,auth, fetcher, user, isLoading, formData, feedbackSent, onFeedbackSubmit, XIcon }
}

})